import React, {
  Dispatch,
  ErrorInfo,
  ReactElement,
  SetStateAction,
} from 'react';

interface ErrorBoundaryProps {
  children: ReactElement<any>;
  fallback: ReactElement<any>;
  setResetKey: Dispatch<SetStateAction<number>>;
}
export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  { error: Error; errorInfo: ErrorInfo }
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
  }

  static getDerivedStateFromError(error: Error, errorInfo: ErrorInfo) {
    return {
      error: error,
      errorInfo: errorInfo,
    };
  }

  componentDidUpdate(
    _prevProps: Readonly<ErrorBoundaryProps>,
    prevState: Readonly<{ error: Error; errorInfo: ErrorInfo }>,
  ) {
    if (prevState?.error) {
      this.props.setResetKey((prev: number) => prev + 1);
    }
  }

  render() {
    if (this.state?.error) {
      // Error path
      return this.props.fallback;
    }
    // Normally, just render children
    return this.props.children;
  }
}
